export const LOGIN_LESSON3_ROUTE = "/loginLesson3";

export const CHAT_LESSON3_ROUTE = "/chatLesson3";